import { IIconProps } from "../types"

export default function IconUR3(props: IIconProps) {
  const width = props.size || props.width || (84 / 5) * 3
  const height = props.size || props.height || (124 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 84 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6158 1.03078C34.2946 0.520945 37.9335 0.211044 40.8525 0.680894C43.7716 1.15074 45.9709 2.41034 48.0102 3.79989C50.0396 5.17945 51.899 6.67897 55.3679 12.0772C58.8368 17.4855 63.9151 26.7925 68.4437 35.8696C72.9722 44.9467 76.9409 53.7739 79.4301 60.6817C81.9094 67.5894 82.899 72.5578 83.029 76.0667C83.159 79.5756 82.4192 81.6349 81.2896 84.3141C80.1599 86.9932 78.6404 90.3122 75.3415 95.1606C72.0425 100.019 66.9541 106.407 62.6855 111.175C58.4169 115.954 54.948 119.113 51.859 120.882C48.77 122.662 46.0608 123.052 42.8019 122.702C39.5429 122.342 35.7342 121.242 30.026 118.553C24.3178 115.874 16.7003 111.615 11.9218 108.496C7.13332 105.377 5.19395 103.408 3.70442 100.689C2.2249 97.9597 1.21522 94.4908 0.745373 90.1922C0.28552 85.8936 0.365495 80.7652 0.955306 74.4572C1.55511 68.1393 2.64476 60.6417 4.85406 50.6649C7.05335 40.6881 10.3523 28.2121 12.9715 19.8547C15.6006 11.4874 17.54 7.22879 20.3791 4.73959C23.2082 2.26039 26.937 1.55061 30.6158 1.03078Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
